<template>
  <div>
    <n-textbox
      ref="emailInput"
      v-model="state.email"
      name="Email"
      :attrs="$attrs"
      autocorrect="off"
      autocapitalize="off"
      :placeholder="props.placeholder"
      :label="props.label"
      :invalid="isInvalid('email', v$)"
      :error="getError('email', v$)"
      @input="handleInput"
      @blur="handleBlur"
      @change="v$.email.$touch"
    />
  </div>
</template>
<script setup>
import { reactive, computed, ref, nextTick, watch, toRefs } from "vue";
import { useValidation, getError, isInvalid } from "nymbl-ui/validation";
import { required, email, helpers } from "@vuelidate/validators";

const emit = defineEmits(["update:isFormInvalid", "update:modelValue"]);

const state = reactive({
  email: null,
});

const props = defineProps({
  isRequired: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: "example@email.com",
  },
  label: {
    type: String,
    default: "Email *",
  },
  modelValue: String,
});

let { modelValue } = toRefs(props);

watch(modelValue, (newValue) => {
  state.email = newValue;
});

const emailInput = ref(null);

const validationRules = computed(() => {
  if (props.isRequired) {
    return {
      email: {
        email: helpers.withMessage(
          "The Email field must be a valid email",
          email,
        ),
        required: helpers.withMessage("The Email field is required", required),
      },
    };
  }
  return {
    email: {
      email: helpers.withMessage("The Email field is required", email),
    },
  };
});

const v$ = useValidation(validationRules, state, { $lazy: true });

const handleInput = () =>
  nextTick(() => {
    emit("update:modelValue", state.email);
    emit("update:isFormInvalid", isInvalid("email", v$.value));
  });

const handleBlur = () =>
  nextTick(() => {
    emit("update:modelValue", state.email.trim());
    emit("update:isFormInvalid", isInvalid("email", v$.value));
  });

const focus = () => emailInput.value.focus();

defineExpose(focus);
</script>
